import { useContext } from "react"
import { AlertContext } from "../contexts/AlertContext.tsx"

const useAlert = () => useContext(AlertContext)

export default useAlert
